<template>
<!--  -->
  <van-tabbar style="max-width:820px;" active-color="#646566" v-model="routename"  >
    <van-tabbar-item name="index" :to="'/shop/'+$store.getters.shop_id">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon.index_active : icon.index" >
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="category" icon="apps-o" to="/category">
      <span>产品</span>
      <template #icon="props">
        <img :src="props.active ? icon.category_active : icon.category" >
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="case" icon="star-o" :to="'/case/'+$store.getters.shop_id">
      <span>案例库</span>
      <template #icon="props">
        <img :src="props.active ? icon.case_active : icon.case" >
      </template>
    </van-tabbar-item>
<!--    <van-tabbar-item name="cart" :badge="count" icon="shopping-cart-o"-->
    <van-tabbar-item name="cart" icon="shopping-cart-o" to="/cart">
      <span>购物车</span>
      <template #icon="props">
        <img :src="props.active ? icon.cart_active : icon.cart" >
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="user" icon="user-o" to="/user">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? icon.user_active : icon.user" >
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  props: {
    count: 0
  },

  data() {
    return {
      badge: 0,
      menutexts: {},
      routename:this.$route.name,
      icon: {
        index: '/roomicon/index.png',
        index_active: '/roomicon/index_active.png',
        category: '/roomicon/category.png',
        category_active: '/roomicon/category_active.png',
        case: '/roomicon/case.png',
        case_active: '/roomicon/case_active.png',
        cart: '/roomicon/cart.png',
        cart_active: '/roomicon/cart_active.png',
        user: '/roomicon/user.png',
        user_active: '/roomicon/user_active.png',
      }
    };
  },
  computed:{
   
  },
  mounted() {
    /*let that = this;
    this.$setMenuText((v) => {

      let new_title = v[that.$route.meta.title];

      if (new_title) {
        document.title = new_title;
      }
    });*/

  }
};
</script>
<style scoped>

</style>
